import type { Template } from "@/types";

export const PO_04_H3_V1: Template[] = [
    {
        id: "po-04-h3v1-01",
        name: "PO 01 - H3V1",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-04-h3_v1_01.png",
        size: [1374, 916],
        style: {},
        slots: [
            { id: "1", x: 105, y: 100, width: 478, height: 716, rotation: 0, imageRotation: 0 },
            { id: "2", x: 878, y: 0, width: 432, height: 300, rotation: 0, imageRotation: 0 },
            { id: "3", x: 878, y: 308, width: 432, height: 300, rotation: 0, imageRotation: 0 },
            { id: "4", x: 878, y: 616, width: 432, height: 300, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-04-h3v1-02",
        name: "PO 02 - H3V1",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-04-h3_v1_02.png",
        size: [1374, 916],
        style: {},
        slots: [
            { id: "1", x: 62, y: 65, width: 525, height: 786, rotation: 0, imageRotation: 0 },
            { id: "2", x: 923, y: 65, width: 390, height: 257, rotation: 0, imageRotation: 0 },
            { id: "3", x: 923, y: 330, width: 390, height: 257, rotation: 0, imageRotation: 0 },
            { id: "4", x: 923, y: 595, width: 390, height: 256, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-04-h3v1-03",
        name: "PO 03 - H3V1",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-04-h3_v1_03.png",
        size: [1374, 916],
        style: {},
        slots: [
            { id: "1", x: 130, y: 65, width: 390, height: 257, rotation: 0, imageRotation: 0 },
            { id: "2", x: 130, y: 330, width: 390, height: 257, rotation: 0, imageRotation: 0 },
            { id: "3", x: 130, y: 595, width: 390, height: 256, rotation: 0, imageRotation: 0 },
            { id: "4", x: 767, y: 65, width: 525, height: 786, rotation: 0, imageRotation: 0 },
        ],
    },
    {
        id: "po-04-h3v1-04",
        name: "PO 04 - H3V1",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-04-h3_v1_04.png",
        size: [1374, 916],
        style: {},
        slots: [        
            { id: "1", x: 88, y: 206, width: 511, height: 322, rotation: 0, imageRotation: 0 },
            { id: "2", x: 88, y: 535, width: 252, height: 176, rotation: 0, imageRotation: 0 },
            { id: "3", x: 347, y: 535, width: 252, height: 176, rotation: 0, imageRotation: 0 },
            { id: "4", x: 767, y: 65, width: 525, height: 786, rotation: 0, imageRotation: 0 },
        ],
    },
    {
        id: "po-04-h3v1-05",
        name: "PO 05 - H3V1",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-04-h3_v1_05.png",
        size: [1374, 916],
        style: {},
        slots: [                   
            { id: "1", x: 88, y: 206, width: 252, height: 176, rotation: 0, imageRotation: 0 },
            { id: "2", x: 347, y: 206, width: 252, height: 176, rotation: 0, imageRotation: 0 },
            { id: "3", x: 88, y: 389, width: 511, height: 322, rotation: 0, imageRotation: 0 },
            { id: "4", x: 861, y: 206, width: 338, height: 505, rotation: 0, imageRotation: 0 },
        ],
    },

    {
        id: "po-04-h3v1-06",
        name: "PO 06 - H3V1",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-04-h3_v1_06.png",
        size: [1374, 916],
        style: {},
        slots: [
            { id: "1", x: 57, y: 187, width: 574, height: 360, rotation: 0, imageRotation: 0 },
            { id: "2", x: 57, y: 555, width: 283, height: 192, rotation: 0, imageRotation: 0 },
            { id: "3", x: 348, y: 555, width: 282, height: 192, rotation: 0, imageRotation: 0 },
            { id: "4", x: 687, y: 1, width: 686, height: 916, rotation: 0, imageRotation: 0 }
        ],
    },
    {
        id: "po-04-h3v1-07",
        name: "PO 07 - H3V1",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-04-h3_v1_07.png",
        size: [1374, 916],
        style: {},
        slots: [
            { id: "1", x: 81, y: 65, width: 525, height: 786, rotation: 0, imageRotation: 0 },
            { id: "2", x: 775, y: 388, width: 511, height: 322, rotation: 0, imageRotation: 0 },
            { id: "3", x: 1034, y: 205, width: 252, height: 176, rotation: 0, imageRotation: 0 },
            { id: "4", x: 775, y: 205, width: 252, height: 176, rotation: 0, imageRotation: 0 }
        ],
    },
    {
        id: "po-04-h3v1-08",
        name: "PO 08 - H3V1",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-04-h3_v1_08.png",
        size: [1374, 916],
        style: {},
        slots: [
            { id: "1", x: 0, y: 195, width: 337, height: 259, rotation: 0, imageRotation: 0 },
            { id: "2", x: 0, y: 462, width: 337, height: 259, rotation: 0, imageRotation: 0 },
            { id: "3", x: 345, y: 195, width: 682, height: 525, rotation: 0, imageRotation: 0 },
            { id: "4", x: 1036, y: 195, width: 337, height: 525, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-04-h3v1-09",
        name: "PO 09 - H3V1",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-04-h3_v1_09.png",
        size: [1374, 916],
        style: {},
        slots: [
            { id: "1", x: 57, y: 63, width: 500, height: 791, rotation: 0, imageRotation: 0 },
            { id: "2", x: 564, y: 609, width: 373, height: 245, rotation: 0, imageRotation: 0 },
            { id: "3", x: 564, y: 63, width: 754, height: 538, rotation: 0, imageRotation: 0 },
            { id: "4", x: 945, y: 609, width: 373, height: 245, rotation: 0, imageRotation: 0 }      
        ],
    },

    {
        id: "po-04-h3v1-10",
        name: "PO 10 - H3V1",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-04-h3_v1_10.png",
        size: [1374, 916],
        style: {},
        slots: [
            { id: "1", x: 210, y: 86, width: 297, height: 421, rotation: 0, imageRotation: 0 },
            { id: "2", x: 210, y: 515, width: 473, height: 317, rotation: 0, imageRotation: 0 },
            { id: "3", x: 514, y: 86, width: 650, height: 421, rotation: 0, imageRotation: 0 },
            { id: "4", x: 691, y: 515, width: 473, height: 317, rotation: 0, imageRotation: 0 }
        ],
    },
];


